import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

const teal = '#0D9488'
const plum = '#1E1040'
const cream = '#FAF7F2'

export default function Contact() {
  useEffect(() => { window.scrollTo(0, 0) }, [])

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <Link to="/" style={styles.back}>← Back</Link>
        <h1 style={styles.h1}>Contact</h1>

        <p style={styles.lead}>
          Need help, want to share feedback, or have a question about your account?
          We read every email. Plain English, real human on the other end.
        </p>

        <div style={styles.card}>
          <div style={styles.icon}>📧</div>
          <h2 style={styles.cardTitle}>Email</h2>
          <p style={styles.cardSub}>The fastest way to reach us. Most replies within 24 hours.</p>
          <a href="mailto:hello@getmerq.com" style={styles.cta}>hello@getmerq.com</a>
        </div>

        <h2 style={styles.h2}>Where to Reach Us</h2>
        <ul style={styles.ul}>
          <li><strong>General questions, feedback, ideas</strong> — <a href="mailto:hello@getmerq.com" style={styles.link}>hello@getmerq.com</a></li>
          <li><strong>Subscription and billing</strong> — <a href="mailto:support@getmerq.com" style={styles.link}>support@getmerq.com</a></li>
          <li><strong>Account access and password issues</strong> — <a href="mailto:support@getmerq.com" style={styles.link}>support@getmerq.com</a></li>
          <li><strong>Privacy, data requests, account deletion</strong> — <a href="mailto:legal@getmerq.com" style={styles.link}>legal@getmerq.com</a></li>
          <li><strong>Press and partnerships</strong> — <a href="mailto:hello@getmerq.com" style={styles.link}>hello@getmerq.com</a></li>
        </ul>

        <h2 style={styles.h2}>About Merq Log</h2>
        <p style={styles.p}>
          Merq Log is a receipt and mileage tracking app built for self-employed people, freelancers,
          and contractors. Snap a photo of any receipt, log a trip in seconds, and generate
          tax-ready Schedule C reports at year-end. Just $29 a year.
        </p>
        <p style={styles.p}>
          Merq Log is part of the <a href="https://getmerq.com" style={styles.link} target="_blank" rel="noopener noreferrer">Merq Software</a>{' '}
          family of small-business tools, based in Texas, United States.
        </p>

        <div style={styles.footer}>
          <Link to="/privacy" style={styles.footerLink}>Privacy Policy</Link>
          <Link to="/terms" style={styles.footerLink}>Terms of Service</Link>
          <Link to="/refunds" style={styles.footerLink}>Refund Policy</Link>
        </div>
      </div>
    </div>
  )
}

const styles = {
  page: { minHeight: '100vh', background: cream, fontFamily: "'Plus Jakarta Sans', sans-serif", color: plum, padding: '40px 20px 80px' },
  container: { maxWidth: '760px', margin: '0 auto' },
  back: { color: teal, textDecoration: 'none', fontSize: '14px', fontWeight: 600 },
  h1: { fontFamily: "'Fraunces', serif", fontSize: '40px', fontWeight: 900, letterSpacing: '-1px', margin: '20px 0 24px 0' },
  lead: { fontSize: '16px', lineHeight: 1.7, marginBottom: '32px', color: '#374151' },
  card: {
    background: '#fff',
    border: '1.5px solid #E5E7EB',
    borderRadius: '20px',
    padding: '32px 28px',
    textAlign: 'center',
    marginBottom: '40px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.04)',
  },
  icon: { fontSize: '40px', marginBottom: '12px' },
  cardTitle: {
    fontFamily: "'Fraunces', serif",
    fontSize: '24px',
    fontWeight: 800,
    margin: '0 0 8px 0',
    letterSpacing: '-0.4px',
  },
  cardSub: { fontSize: '14px', color: '#6B7280', marginBottom: '20px' },
  cta: {
    display: 'inline-block',
    padding: '12px 24px',
    background: teal,
    color: '#042f2e',
    borderRadius: '100px',
    fontSize: '15px',
    fontWeight: 800,
    textDecoration: 'none',
    boxShadow: `0 6px 18px ${teal}40`,
  },
  h2: {
    fontFamily: "'Fraunces', serif",
    fontSize: '24px',
    fontWeight: 800,
    letterSpacing: '-0.4px',
    marginTop: '40px',
    marginBottom: '14px',
  },
  p: { fontSize: '15px', lineHeight: 1.65, color: '#374151', marginBottom: '14px' },
  ul: { fontSize: '15px', lineHeight: 1.85, color: '#374151', paddingLeft: '20px', marginBottom: '14px' },
  link: { color: teal, fontWeight: 600 },
  address: {
    fontSize: '14px',
    lineHeight: 1.7,
    color: '#374151',
    background: '#fff',
    padding: '14px 18px',
    borderRadius: '10px',
    border: '1px solid #E5E7EB',
  },
  footer: {
    marginTop: '60px',
    paddingTop: '24px',
    borderTop: '1px solid #E5E7EB',
    display: 'flex',
    gap: '20px',
    flexWrap: 'wrap',
  },
  footerLink: { color: teal, textDecoration: 'none', fontSize: '13px', fontWeight: 600 },
}
